import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { SocialPropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useSocialEconomicDemographicData(queryParams: SocialPropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'residentsByDemographic',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
